import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import { omit } from "lodash";
import { GlobalEntityType } from "shared/types";
import { revokeOwnershipSuccessful, shareOwnershipSuccessful, } from "store/knowledge-base-item/knowledge-base-item.actions";
import { setKnowledgeBaseItemsFilterExcludedTags, setKnowledgeBaseItemsFilterIncludedTags, setKnowledgeBaseItemsLastUsedSortingDirection, setKnowledgeBaseItemsNameSortingDirection, setKnowledgeBaseItemsOwnershipFilter, setKnowledgeBaseItemsSearchQuery, } from "store/knowledge-base-items-list/knowledge-base-items-list.actions";
import { uploadWorkspace, parseWorkspaceFileId, workspaceImportFromFileId, loadWorkspacesList, loadWorkspacesListSuccessful, loadWorkspacesListFailure, parseWorkspaceFileIdSuccessful, uploadWorkspaceSuccessful, workspaceImportFromFileIdSuccessful, uploadWorkspaceFailure, parseWorkspaceFileIdFailure, workspaceImportFromFileIdFailure, workspaceClearParsedData, } from "./rs-workspace-list.actions";
import initialState from "./rs-workspace-list.store";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(loadWorkspacesListSuccessful, (state, { payload }) => {
        state.items = payload;
    })
        .addCase(setKnowledgeBaseItemsSearchQuery, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.RsWorkspace) {
            state.searchQuery = payload.query;
        }
    })
        .addCase(setKnowledgeBaseItemsOwnershipFilter, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.RsWorkspace) {
            state.ownershipFilter = payload.ownershipFilter;
        }
    })
        .addCase(setKnowledgeBaseItemsNameSortingDirection, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.RsWorkspace) {
            state.sortingDirections.name = payload.direction;
        }
    })
        .addCase(setKnowledgeBaseItemsLastUsedSortingDirection, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.RsWorkspace) {
            state.sortingDirections.lastUsed = payload.direction;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterIncludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.RsWorkspace) {
            state.tagsFilters.included = payload.tags;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterExcludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.RsWorkspace) {
            state.tagsFilters.excluded = payload.tags;
        }
    })
        .addCase(parseWorkspaceFileIdSuccessful, (state, { payload }) => {
        state.parsedData = payload;
    })
        .addCase(uploadWorkspaceSuccessful, (state, { payload }) => {
        state.importFileId = payload;
    })
        .addMatcher(isAnyOf(shareOwnershipSuccessful, revokeOwnershipSuccessful), (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.RsWorkspace) {
            const existingItem = state.items.find(({ id }) => id === payload.knowledgeBaseItem.id);
            if (state.items) {
                state.items = [
                    ...state.items.filter(({ id }) => id !== payload.knowledgeBaseItem.id),
                    { ...existingItem, ...omit(payload.knowledgeBaseItem, "state") },
                ];
            }
        }
    })
        .addMatcher(isAnyOf(uploadWorkspace, workspaceImportFromFileIdSuccessful, workspaceClearParsedData), (state) => {
        state.importFileId = null;
        state.parsedData = null;
    })
        .addMatcher(isAnyOf(uploadWorkspace, parseWorkspaceFileId, workspaceImportFromFileId, loadWorkspacesList), (state) => ({
        ...state,
        loading: true,
    }))
        .addMatcher(isAnyOf(uploadWorkspaceFailure, parseWorkspaceFileIdSuccessful, parseWorkspaceFileIdFailure, workspaceImportFromFileIdSuccessful, workspaceImportFromFileIdFailure, loadWorkspacesListFailure, loadWorkspacesListSuccessful), (state) => ({
        ...state,
        loading: false,
    }));
});
